import React, { useEffect, useState } from "react"

// assets
import IconCalcute from './icon-calcute'
import IconReset from './icon-reset'
import ShapeCloud from './shape-cloud'

import moment from "moment"
import FormGetNumber from "../formNumberCountry"

import WomanFat from './woman-fat'
import WomanStab from './woman-stab'
import WomanSlim from './woman-slim'
import ManFat from './man-fat'
import ManStab from './man-stab'
import ManSlim from './man-slim'

const BottomSheet = (props) => {
	const { actionType, data } = props
	const [CurrentDate, setCurrentDate] = useState('')
	const [HealthDate, setHealthDate] = useState('')
	const [WeightDistance, setWeightDistance] = useState()
	const [Month, setMonth] = useState()
	const [Type, setType] = useState('')

	useEffect(() => {
		calcuteData()
		findDate()
	}, [data])
	function calcuteData() {
		if (data.bmi <= 18 && data.gender_id === '1') { setType('diet1_women') }
		else if (data.bmi <= 18 && data.gender_id === '2') { setType('diet1_men') }
		else if (data.bmi > 18 && data.bmi < 25 && data.gender_id === '1') { setType('diet4_women') }
		else if (data.bmi > 18 && data.bmi < 25 && data.gender_id === '2') { setType('diet4_men') }
		else if (data.bmi >= 25 && data.gender_id === '1') { setType('diet5_women') }
		else if (data.bmi >= 25 && data.gender_id === '2') { setType('diet5_men') }
	}
	function findDate() {
		setWeightDistance(data.weight - data.normal_weight)
		let now = new Date()
		let Current_Date = moment(now).format('MMMM YYYY')
		let healthWeightInMonth = Math.floor(Math.abs(data.days_require) / 30)
		setMonth(healthWeightInMonth)
		let healthWeight_Date = new Date(now.setMonth(now.getMonth() + healthWeightInMonth))
		let final_date = moment(healthWeight_Date).format('MMMM YYYY')
		setCurrentDate(Current_Date)
		setHealthDate(final_date)
	}

	return <>
		<div className={`bottomSheet ${actionType === 'calcute' ? 'hide' : 'is-active'}`}>
			<button
				className="action"
				onClick={() => props.action()}
			>
				{actionType === 'calcute' ? <>
					<IconCalcute />أحسب وزنك المثالي</> : <><IconReset />أحسب مرة اخرى</>}
			</button>

			{actionType === 'reset' ? <div className="bottomsheet_content">
				<div className="weight_shape_result">
					<ShapeCloud />
					<div className="user_bmi">
						<div className="box1">
							<div className="box_weight best_weight">
								<span className="title">وزنـك المثـالي</span>
								<div className="value">{data.normal_weight}<span className="unit">Kg</span></div>
							</div>
							<div className="box_weight current_weight">
								<span className="title">وزنـك الحالي</span>
								<div className="value">{data.weight}<span className="unit">Kg</span></div>
							</div>
						</div>
						<div className="box2">
							{Type === 'diet1_women' && <><WomanSlim /><WomanStab /></>}
							{Type === 'diet1_men' && <><ManSlim /><ManStab /></>}

							{Type === 'diet4_women' && <><WomanStab /><WomanSlim /></>}
							{Type === 'diet4_men' && <><ManStab /><ManSlim /></>}

							{Type === 'diet5_women' && <><WomanFat /><WomanSlim /></>}
							{Type === 'diet5_men' && <><ManFat /><ManSlim /></>}
						</div>
						<div className="box3" dir="ltr">
							{data.bmi < 21 && <span className="caption">في {Math.round(Math.abs(WeightDistance / 2)) || 1} اشهر فقط</span>}
							{data.bmi >= 21 && <span className="caption">في {Math.round(Math.abs(WeightDistance / 4)) || 1} اشهر فقط</span>}
						</div>
					</div>
				</div>
				<div className="user_report">
					{Type === 'diet1_women' && <><h1>احذري لديك <span>{Math.abs(WeightDistance)} كيلو  نقص</span> في الوزن!</h1></>}
					{Type === 'diet1_men' && <>احذر عندك <span>{Math.abs(WeightDistance)} كيلو نقص</span> في الوزن</>}
					{Type === 'diet4_women' && <><span>{Math.abs(WeightDistance)} كيلو</span> بينكِ وبين الصحة والرشاقة </>}
					{Type === 'diet4_men' && <><span>{Math.abs(WeightDistance)} كيلو</span> بينك و بين الصحة والرشاقة</>}
					{Type === 'diet5_women' && <>احذري لديك <span>{Math.abs(WeightDistance)} كيلو</span> وزن زائد!</>}
					{Type === 'diet5_men' && <>احذر عندك <span>{Math.abs(WeightDistance)} كيلو زيادة</span> في الوزن</>}


					{Type === 'diet1_women' && <p>افعلهيــــــــــا الأن <span>وحققي الوزن المثالي</span></p>}
					{Type === 'diet1_men' && <p>لا تتـردد افعلها الآن  <span>وحقق وزنـك المثالي</span></p>}
					{Type === 'diet4_women' && <p>افعلهيــــــــــا الأن <span>و لا تترددي</span></p>}
					{Type === 'diet4_men' && <p>افعلهــــــــــا الآن،  <span>انت الناجــــــح القــــــادم</span></p>}
					{Type === 'diet5_women' && <p>افعلهيــــــــــا الأن <span>وحققي الوزن المثالي</span></p>}
					{Type === 'diet5_men' && <p>لا تتـردد افعلها الآن  <span>وحقق وزنـك المثالي</span></p>}
				</div>
				<div className="form_container">
					{Type === 'diet1_women' && <h4>سجلي رقمك هنا، واحجزي استشارتك الأن</h4>}
					{Type === 'diet1_men' && <h4>أكتب رقمـك وأحجــز استشـارتك الأن</h4>}
					{Type === 'diet4_women' && <h4>سجلي رقم هاتفك، واحجزي استشارتك الأن</h4>}
					{Type === 'diet4_men' && <h4>أكتب رقمـك وأحجــز استشـارتك الأن</h4>}
					{Type === 'diet5_women' && <h4>سجلي رقمك هنا، واحجزي استشارتك الأن</h4>}
					{Type === 'diet5_men' && <h4>أكتب رقمـك وأحجــز استشـارتك الأن</h4>}
					<FormGetNumber user={WeightDistance} />
				</div>
			</div> : null}
		</div>
	</>
}
export default BottomSheet